import { GridCellParams } from '@material-ui/data-grid';
import { Paper, Tabs, Tab, Toolbar } from '@material-ui/core';
import {
  GridHeader,
  LoadingIndicator,
  TabPanel,
} from '../../../components';
import {getDataHead, GetDataBody, headerExport, getDataExport, getDataExportColaborador, headerExportColaborador} from './columnsGetter';
import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCRUD, useNotifications } from '../../../hooks';
import SalesMap from '../../sells/grid/Map';
import { AuthContext } from '../../../App';
import { sellsService, usersService } from '../../../services';
import { SELL_STATUSES } from '../../sells/form/options';
import { CustomGridTable } from "../../../components/grid/CustomGrid";
import { changeViewColumn } from '../../../components/grid/CustomGrid/Funtions';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import 'moment/locale/es';
import { DELIVERY_STATUSES } from '../../../constants';
import { Button } from '@material-ui/core';



const DailyListGrid = () => {
  const history = useHistory();
  const { showNotification } = useNotifications();
  type Venta = {
    nroVenta: number;
    [key: string]: any; // opcional, para permitir otras propiedades
  };

  const [rows, setRows] = useState<Venta[]>([]);
  const [loading, setLoading] = useState(true);
  const [deliveryMans, setDeliveryMans] = useState([]);
  const [loadingDeliveryMans, setLoadingDeliveryMans] = useState(true);
  let dataToHeadVentas = sessionStorage.getItem('filterToDDateVentas');
  let dataFromHeadVentas = sessionStorage.getItem('filterFromDDateVentas');
	const [fromDate, setFromDate] = useState(moment(dataFromHeadVentas?dataFromHeadVentas:undefined).format("YYYY-MM-DD 00:00:00"));
	const [toDate, setToDate] = useState(moment(dataToHeadVentas?dataToHeadVentas:undefined).format("YYYY-MM-DD 23:59:59"));

  useEffect(() => {
    let dataToHeadVentas = sessionStorage.getItem('filterToDDateVentas');
    if (dataToHeadVentas) {
      setToDate(dataToHeadVentas);
    }
    let dataFromHeadVentas = sessionStorage.getItem('filterFromDDateVentas');
    if (dataFromHeadVentas) {
      setFromDate(dataFromHeadVentas);
    }
  }, [])

  const enrichMayorista2Sales = async (sales: Venta[]) => {
    const mayorista2Sales = sales.filter((sale) => sale.client?.typeclient === 4);
    if (mayorista2Sales.length === 0) return sales;

    const details = await Promise.all(
      mayorista2Sales.map((sale) =>
        sellsService.find(sale.nroVenta).catch(() => null)
      )
    );

    const detailMap = new Map(
      details.filter(Boolean).map((detail: any) => [detail.nroVenta, detail])
    );

    return sales.map((sale) => {
      const detail = detailMap.get(sale.nroVenta);
      if (!detail) return sale;
      return {
        ...sale,
        ...detail,
        product: detail.product ?? sale.product,
        productCar: detail.productCar ?? sale.productCar,
        client: detail.client ?? sale.client,
        seller: detail.seller ?? sale.seller,
        collaborator: detail.collaborator ?? sale.collaborator,
        deliveryMan: detail.deliveryMan ?? sale.deliveryMan,
        open: sale.open,
      };
    });
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const delivery = await usersService.getDeliverymans();
        if (isMounted) setDeliveryMans(delivery);
      } finally {
        if (isMounted) setLoadingDeliveryMans(false);
      }

      try {
        const sales = await sellsService.getSalesNotApprovedForToday({
          fromDate: moment(fromDate).format("YYYY-MM-DD 00:00:00"),
          toDate: moment(toDate).format("YYYY-MM-DD 23:59:59"),
        });
        const enriched = await enrichMayorista2Sales(sales);
        if (isMounted) setRows(enriched);
      } finally {
        if (isMounted) setLoading(false);
        // sellsService.getUpdateOldSales();
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [fromDate,toDate])

  const {
    handleRemove
  } = useCRUD(
    async () => {},
    sellsService.add,
    sellsService.edit,
    sellsService.remove,
    showNotification,
    sellsService.getMessages,
    (sell: any) => sell.nroVenta
  );

  const deliveryManOptions = deliveryMans.map((x: any) => ({
    value: x.id,
    description: `${x.firstName} ${x.lastName}`,
  }));
  
  const querystring = window.location.search
  const params = new URLSearchParams(querystring)

  const [tabValue, setTabValue] = useState(parseInt(params.get('tab') || "0"));
  const { userState } = useContext(AuthContext);
  
  const [selectedRemitos, setSelectedRemitos] = useState<number[]>([]);

  const toggleSelectRemito = (nroVenta: number) => {
    setSelectedRemitos(prev =>
      prev.includes(nroVenta)
        ? prev.filter(id => id !== nroVenta)
        : [...prev, nroVenta]
    );
  };

  const isRemitoSelected = (nroVenta: number) => selectedRemitos.includes(nroVenta);

  const handlePrintSelected = () => {
    const seleccionados = rows.filter(row => selectedRemitos.includes(row.nroVenta));

    const queryString = seleccionados.map(r => `nroVenta=${r.nroVenta}`).join('&');
    const url = `/ventas/masivos?${queryString}`;

    window.open(url, '_blank');
  };


  const toggleSelectAll = () => {
    if (selectedRemitos.length === rows.length) {
      setSelectedRemitos([]);
    } else {
      const allIds = rows.map(row => row.nroVenta);
      setSelectedRemitos(allIds);
    }
  };


  const onEdit = (params: GridCellParams) => {
    history.push('/ventas/editar', { ...params.row });
  };

  const updateStatus = (params: GridCellParams, newStatusValue: number) => {
    const sellIndex = rows.findIndex(
      (row:any) => row.nroVenta === params.row.nroVenta
    );
    let newSells = [...rows];
    if (newStatusValue===SELL_STATUSES.rejected) {
      newSells[sellIndex] = { ...newSells[sellIndex], salestate: newStatusValue, deliverystate: DELIVERY_STATUSES.canceled};
    } else {
      newSells[sellIndex] = { ...newSells[sellIndex], salestate: newStatusValue };
    }
    setRows(newSells);
  };

  const onCancel = async (params: GridCellParams) => {
    try {
      setLoading(true);
      const nroVenta = params.row.nroVenta;
      await sellsService.changeStatus(nroVenta, SELL_STATUSES.rejected);
      // await sellsService.changeDeliveryState(nroVenta, DELIVERY_STATUSES.canceled,"Venta cancelada");

      updateStatus(params, SELL_STATUSES.rejected);
      showNotification('success', 'Venta cancelada correctamente');
    } catch (e) {
      showNotification('error', 'Se produjo un error al cancelar la venta');
    } finally {
      setLoading(false);
    }
  };

  const onApprove = async (params: GridCellParams) => {
    try {
      setLoading(true);
      const nroVenta = params.row.nroVenta;
      await sellsService.changeStatus(nroVenta, SELL_STATUSES.approved);

      updateStatus(params, SELL_STATUSES.approved);
      showNotification('success', 'Venta aprobada correctamente');
    } catch (e) {
      showNotification('error', 'Se produjo un error al aprobar la venta');
    } finally {
      setLoading(false);
    }
  };

  const onAssignDeliveryMan = async (
    sellNumber: number,
    deliveryManId: number
  ) => {
    try {
      setLoading(true);
      await sellsService.assignDeliveryMan(sellNumber, deliveryManId);
      const sellIndex = rows.findIndex((row:any) => row.nroVenta === sellNumber);
      const deliveryManIndex = deliveryMans.findIndex(
        (row: any) => row.id === deliveryManId
      );
      const newDeliveryMan = deliveryMans[deliveryManIndex];
      let newSells = [...rows];
      newSells[sellIndex] = {
        ...newSells[sellIndex],
        deliveryMan: newDeliveryMan,
      };
      setRows(newSells);
      setLoading(false);
      showNotification('success', 'Repartidor asignado correctamente');
    } catch (e) {
      showNotification(
        'error',
        'Se produjo un error al intentar asignar al repartidor'
      );
    }
  };

  const allowAdd =
    userState.type === 'admin' || userState.type === 'collaborator';

    const [dataHeadColumns, setDataHeadColumns] = useState(getDataHead(userState.type));
  
    const handleChangeViewColumn = (key: string) => {
      changeViewColumn(key, "dataHeadDailyList", dataHeadColumns, setDataHeadColumns)
    }
    
    const setOpen = (id: any, open:boolean) => {
      let newSells = [...rows];
      let sellIndex = rows.findIndex(
        (row:any) => row.nroVenta === id
      );
      newSells[sellIndex] = {
        ...newSells[sellIndex],
        open: open,
      };
      setRows(newSells);
    }
    
    const [page, setPage] = useState(parseInt(params.get('page') || "0"));
    const changePage = (newPage: number) => {
      history.push(`?page=${newPage}`)
      setPage(newPage);
    }
    
    const onDeliveryStatus = async (
      params: GridCellParams
    ) => {
      try {
        setLoading(true);
        await sellsService.changeDeliveryState(params.row.nroVenta, 2,'Entregado');
        const sellIndex = rows.findIndex((row:any) => row.nroVenta === params.row.nroVenta);
        let newSells = [...rows];
        newSells[sellIndex] = {
          ...newSells[sellIndex],
          deliverystate: 2,
        };
        setRows(newSells);
        setLoading(false);
        showNotification('success', 'Venta entregada correctamente');
      } catch (e) {
        showNotification(
          'error',
          'Se produjo un error al intentar entregar la venta'
        );
      }
    };

  return (
    <>
      <LoadingIndicator loading={loading || loadingDeliveryMans} />

      <GridHeader
        addUrl="ventas/agregar"
        title="Listado Diario"
        buttonText={allowAdd ? 'Nueva venta' : ''}
      >
        <>
          <Paper square>
            <Tabs
              value={tabValue}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, val) => {
                val !== 0 ? history.push(`?page=${params.get('page')||0}&tab=${val}`) : history.push(`?page=${params.get('page')||0}`);
                setTabValue(val);
              }}
              aria-label="disabled tabs example"
            >
              <Tab label="Tabla" />
              <Tab label="Mapa" />
            </Tabs>
          </Paper>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="fromDate"
            value={moment(fromDate).isValid() ? moment(fromDate).format("YYYY-MM-DD 00:00:00") : null}
            onChange={(e)=>{
              setFromDate(moment(e).isValid() ? moment(e).format("YYYY-MM-DD 00:00:00") : "");
              sessionStorage.setItem('filterFromDDateVentas',moment(e).isValid() ? moment(e).format("YYYY-MM-DD 00:00:00") : "");
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="toDate"
            value={moment(toDate).isValid() ? moment(toDate).format("YYYY-MM-DD 23:59:59") : null}
            onChange={(e)=>{
              setToDate(moment(e).isValid() ? moment(e).format("YYYY-MM-DD 23:59:59") : "");
              sessionStorage.setItem('filterToDDateVentas',moment(e).isValid() ? moment(e).format("YYYY-MM-DD 23:59:59") : "");
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            />
          </MuiPickersUtilsProvider>
        </>
      </GridHeader>

      <TabPanel value={tabValue} index={0}>
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={toggleSelectAll}>
            {selectedRemitos.length === rows.length ? 'Deseleccionar todos' : 'Seleccionar todos'}
          </Button>
          {selectedRemitos.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handlePrintSelected}
              >
                Imprimir Remitos Seleccionados ({selectedRemitos.length})
              </Button>
          )}
      </Toolbar>
      <CustomGridTable
          cellsHead={dataHeadColumns} 
          rowsBody={GetDataBody({
            rows,
            onEdit,
            onDelete: handleRemove,
            onApprove,
            onCancel,
            onAssignDeliveryMan,
            deliveryManOptions,
            userType: userState.type,
            setOpen,
            onDeliveryStatus,
            selectedRemitos,
            toggleSelectRemito
          })}
          pageSize={10} 
          pageParent={page}
          changePage={changePage}
          tableProps={{stickyHeader: true, size:"small"}}
          rowsPerPageOptions={[5, 10, 25]}
          toolbarProps={{
            exportProps: {
              data:userState.type==="collaborator" ? getDataExportColaborador(rows) : getDataExport(rows, userState.type), headers:userState.type==="collaborator" ? headerExportColaborador : headerExport, filename:"daily-list.csv", name:"daily-list"
            },
            filterProps: {
              columns: dataHeadColumns,
              handleChangeViewColumn
            }
          }}
          orderDefault={"desc"}
          orderByDefault={dataHeadColumns[1].key}
          idStoreFilter="filtrosListadoDiario"
        />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <div style={{ height: '75vh', width: '100%' }}>
          <SalesMap data={rows} delivery={{options:deliveryManOptions,action:onAssignDeliveryMan}} />
        </div>
      </TabPanel>
    </>
  );
};

export default DailyListGrid;
